module.exports = __webpack_public_path__ + "img/quickbook_logo2.f13d8914.png";